<template>
  <div>
    <h5 role="button" @click="open = !open">
      <i v-if="!open" class="fas fa-angle-right"></i>
      <i v-if="open" class="fas fa-angle-down"></i>
      {{ title }}
    </h5>
    <b-collapse v-model="open" ref="collapse">
      <ais-range-input
        :attribute="attribute"
        :precision="precision"
      >
        <template
          v-slot="{
          currentRefinement,
          range,
          canRefine,
          refine,
          sendEvent,
        }">
          <div class="form-inline">
          <input
            class="form-control form-control-sm"
            type="number"
            :min="range.min"
            :max="range.max"
            :placeholder="range.min"
            :disabled="!canRefine"
            :value="formatMinValue(currentRefinement.min, range.min)"
            @input="refine({
              min:$event.currentTarget.value,
              max: formatMaxValue(currentRefinement.max, range.max),
            })"/>
          <i class="fas fa-arrow-right mx-2"></i>
          <input
            class="form-control form-control-sm"
            type="number"
            :min="range.min"
            :max="range.max"
            :placeholder="range.max"
            :disabled="!canRefine"
            :value="formatMaxValue(currentRefinement.max,range.max)"
            @input="refine({
              min:formatMinValue(currentRefinement.min, range.min),
              max: $event.currentTarget.value,
            })"/>
          </div>
        </template>
      </ais-range-input>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "StyledRangeInput",
  data() {
    return {
      open: false,
    }
  },
  props: {
    title: String,
    attribute: String,
    precision: Number,
  },
  methods: {
    formatMinValue(minValue, minRange) {
      return minValue !== null && minValue !== minRange ? minValue : '';
    },
    formatMaxValue(maxValue, maxRange) {
      return maxValue !== null && maxValue !== maxRange ? maxValue : '';
    },
  }
}
</script>

<style scoped>

</style>
